/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { Route, Switch } from 'react-router-dom';
import { Breadcrumb, SideNav } from '@cambridgeassessment/cambridge-ui';
import { useDispatch, useSelector } from 'react-redux';
import { useDynamicRoutes } from '../../hooks';
import { PageContainer } from '../Landing/Landing.styles';
import { RouteContainer } from './Content.styles';
import { breadCrumbs } from './breadCrumbs';
import Series from './Series';
import Components from './Components';
import SubmissionReports from './Reports/SubmissionReports';
import TrainingReports from './Reports/TrainingReports';
import ReplacementFiles from './ReplacementFiles';
import ConsortiaManagement from './ConsortiaManagement';
import MalpracticeReports from './MalpracticeReports';
import SubmissionFailuresPage from './RMSubmissionFailures/SubmissionFailuresPage';
import { RootState } from '../../store';
import { DynamicRoute } from '../../constants/routes';
import { ConfigureComponent } from './Components/Configure/ConfigureComponent';
import { ComponentDeadlines } from './Components/Deadlines/ComponentDeadlines';
import ConsortiumForm from './ConsortiaManagement/ConsortiumForm';
import WorkDownloading from './WorkDownloading/WorkDownloading';
import { ManageSampleChanges } from './ManageSampleChanges/ManageSampleChanges';
import { resetStateFull } from '../../store/samplesManagement/actions';
import { Roles } from '@cambridgeassessment/lib-ee-commons';
import { Authorized } from 'lib-browser';

export const Content: React.FC = () => {
  const dispatch = useDispatch();

  const { businessUnit, selectedRole } = useSelector((state: RootState) => state.userData);
  const dynamicRoutes = useDynamicRoutes(selectedRole, businessUnit?.id);
  const sideNavOnlyRoutes = dynamicRoutes.filter((route: DynamicRoute) => route.sideNavRoute);

  useEffect(() => {
    return () => {
      dispatch(resetStateFull());
    };
  }, []);

  return (
    <PageContainer>
      {dynamicRoutes.length && <SideNav routes={sideNavOnlyRoutes} />}
      <RouteContainer>
        <Breadcrumb links={breadCrumbs(dynamicRoutes)} separator='/' dataQaId='breadcrumbs' />
        <Switch>
          <Authorized
            selectedRole={selectedRole}
            roles={[
              Roles.SUBMIT_SUPER_ADMIN,
              Roles.SUBMIT_ADMINISTRATOR,
              Roles.SUBMIT_COMPLIANCE,
              Roles.SUBMIT_INTERNAL_ASSESSMENT_MANAGER,
            ]}
          >
            <Route exact path='/submissionReports' component={SubmissionReports} />
            <Route exact path='/series' component={Series} />
            <Route exact path='/trainingReports' component={TrainingReports} />
            <Route exact path='/components' component={Components} />
            <Route exact path='/components/review-configure-component/:componentId' component={ConfigureComponent} />
            <Route exact path='/components/configure-component/:componentId' component={ConfigureComponent} />
            <Route exact path='/components/configure-component/:componentId/deadlines' component={ComponentDeadlines} />
            <Route exact path='/replacementFiles' component={ReplacementFiles} />
            <Route path='/malpracticeReports' component={MalpracticeReports} />
            <Route exact path='/manageConsortia' component={ConsortiaManagement} />
            <Switch>
              <Route exact path='/manageConsortia/editConsortium/:editConsortiumId' component={ConsortiumForm} />
              <Route
                exact
                path='/manageConsortia/createNewConsortium/:duplicateConsortiumId?'
                component={ConsortiumForm}
              />
            </Switch>
            <Route exact path='/downloadCandidateWork' component={WorkDownloading} />
            <Route exact path='/manageSampleChanges' component={ManageSampleChanges} />
            <Route exact path='/resendFilesToRm' component={SubmissionFailuresPage} />
          </Authorized>
        </Switch>
      </RouteContainer>
    </PageContainer>
  );
};

export default Content;
